import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { logoutUser } from '../redux/slices/authSlice';
import { useNavigate } from 'react-router-dom';

const Navbar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.user); // Récupérer l'utilisateur connecté

  const handleLogout = () => {
    dispatch(logoutUser());
    navigate('/login'); // Rediriger vers la page de connexion après déconnexion
  };

  return (
    <nav className="bg-gradient-to-r from-gradientStart to-gradientEnd text-white p-4 flex justify-between items-center shadow-md">
      {/* Logo + Nom Evalse */}
      <div className="flex items-center space-x-3">
        <img src="/images/logo.png" alt="EVALSE" className="h-10 object-contain" />
        <h1 className="text-2xl font-bold">EVALSE</h1>
      </div>

      {/* Email utilisateur + Déconnexion */}
      <div className="flex items-center space-x-4">
        {user && <span className="hidden sm:block">{user.email}</span>} {/* Afficher l'email si l'utilisateur est connecté */}
        <button
          onClick={handleLogout}
          className="bg-white text-primary px-4 py-2 rounded-lg font-semibold hover:bg-opacity-80 transition duration-200"
        >
          Déconnexion
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
